export const validateData = (data) => {
    // Check if data object exists
    if (!data) {
        console.error('Data object is missing.');
        return false;
    }

    // Check if question property exists
    if (!data.question) {
        console.error('Question is missing.');
        return false;
    }

    // Check if correct_answer property exists and has both value and name properties
    if (!data.correct_answer || !data.correct_answer.value || !data.correct_answer.name) {
        console.error('Correct answer is incomplete.');
        return false;
    }

    // Check if questions property exists and has 4 values
    if (!data.questions || Object.keys(data.questions).length !== 4) {
        console.error('Questions are missing or incomplete.');
        return false;
    }

    // Check each question in the questions object
    for (let key in data.questions) {
        const question = data.questions[key];

        // Check if each question has both value and name properties
        if (!question || !question.value || !question.name) {
            console.error(`Question ${key} is incomplete.`);
            return false;
        }
    }

    // All checks passed
    return true;
}
export const quizValidateData = (data) => {
    // Check if data object exists
    if (!data) {
        console.error('Data object is missing.');
        return false;
    }

    // Check if question property exists
    if (!data.name) {
        console.error('Name is missing.');
        return false;
    }
    if (!data.Duration) {
        console.error('Duration is missing.');
        return false;
    }
    if (!data.password) {
        console.error('Password is missing.');
        return false;
    }

   
    // All checks passed
    return true;
}
export const quizUpdateValidateData = (data) => {
    // Check if data object exists
    if (!data) {
        console.error('Data object is missing.');
        return false;
    }

    // Check if question property exists
    if (!data.quizName) {
        console.error('Name is missing.');
        return false;
    }
    if (!data.quizModule) {
        console.error('Module is missing.');
        return false;
    }

   
    // All checks passed
    return true;
}
